module.exports = __webpack_public_path__ + "static/hiw-bg-064a1865559c62c4dd6d6f9212b8b59b.svg";